// extracted by mini-css-extract-plugin
export default {"body":"FullPost_body__UVdlA","title":"FullPost_title__vahNX","date":"FullPost_date__cz+4J"};